import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '/api';

export default function Tecnico() {
  const [categorias, setCategorias] = useState([]);
  const [categoriaActiva, setCategoriaActiva] = useState<any>(null);
  const [documentos, setDocumentos] = useState([]);
  const [imagenModal, setImagenModal] = useState<string|null>(null);

  useEffect(() => {
    axios.get(`${API}/tecnico/categorias`).then(r => {
      setCategorias(r.data);
      if (r.data.length > 0) setCategoriaActiva(r.data[0]);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (categoriaActiva) {
      axios.get(`${API}/tecnico/categorias/${categoriaActiva.id}/documentos`)
        .then(r => setDocumentos(r.data)).catch(() => {});
    }
  }, [categoriaActiva]);

  const esImagen = (tipo: string) => ['jpg','jpeg','png','webp'].includes(tipo?.toLowerCase());
  const esPdf = (tipo: string) => tipo?.toLowerCase() === 'pdf';

  return (
    <main className="min-h-screen bg-gray-50">
      <div className="bg-azul py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-white/40 text-xs tracking-widest mb-2">INFORMACIÓN TÉCNICA</div>
          <h1 className="font-condensed text-5xl font-black text-white">Centro Técnico</h1>
          <p className="text-white/60 mt-2">Fichas técnicas, recomendaciones y catálogos</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="md:col-span-1">
            <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden sticky top-20">
              <div className="bg-azul px-4 py-3">
                <div className="text-white text-xs font-black tracking-widest">CATEGORÍAS</div>
              </div>
              <div className="p-2">
                {(categorias as any[]).map((c: any) => (
                  <button key={c.id} onClick={() => setCategoriaActiva(c)}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all text-left ${
                      categoriaActiva?.id === c.id ? 'bg-azul text-white' : 'text-gray-600 hover:bg-gray-50'
                    }`}>
                    <span>{c.icono}</span>
                    <span>{c.nombre}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Contenido */}
          <div className="md:col-span-3">
            {categoriaActiva && (
              <div>
                <div className="mb-6">
                  <h2 className="font-condensed text-3xl font-black text-azul">{categoriaActiva.icono} {categoriaActiva.nombre}</h2>
                  {categoriaActiva.descripcion && <p className="text-gray-500 text-sm mt-1">{categoriaActiva.descripcion}</p>}
                </div>

                {documentos.length > 0 ? (
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                    {(documentos as any[]).map((d: any) => (
                      <div key={d.id} className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:border-azul hover:shadow-lg transition-all group">
                        {/* Imagen directa */}
                        {d.archivo_url && esImagen(d.tipo) ? (
                          <div className="relative cursor-pointer" onClick={() => setImagenModal(`https://ticobaterias.com${d.archivo_url}`)}>
                            <img
                              src={`https://ticobaterias.com${d.archivo_url}`}
                              alt={d.titulo}
                              className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                            />
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center">
                              <div className="opacity-0 group-hover:opacity-100 transition-opacity bg-white rounded-full p-2 shadow-lg">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#253789" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
                              </div>
                            </div>
                          </div>
                        ) : d.archivo_url && esPdf(d.tipo) ? (
                          <div className="h-48 bg-red-50 flex flex-col items-center justify-center border-b border-gray-100">
                            <span className="text-5xl mb-2">📕</span>
                            <span className="text-xs text-red-500 font-bold">PDF</span>
                          </div>
                        ) : (
                          <div className="h-48 bg-gray-50 flex items-center justify-center border-b border-gray-100">
                            <span className="text-5xl text-gray-300">📄</span>
                          </div>
                        )}

                        {/* Info */}
                        <div className="p-3">
                          <h3 className="font-bold text-azul text-sm leading-tight mb-1">{d.titulo}</h3>
                          {d.descripcion && <p className="text-gray-400 text-xs mb-2 line-clamp-2">{d.descripcion}</p>}
                          {d.archivo_url && (
                            esImagen(d.tipo) ? (
                              <button onClick={() => setImagenModal(`https://ticobaterias.com${d.archivo_url}`)}
                                className="w-full bg-azul text-white text-xs font-bold py-2 rounded-lg hover:bg-azul-dark transition-colors">
                                👁️ Ver imagen
                              </button>
                            ) : (
                              <a href={`https://ticobaterias.com${d.archivo_url}`} target="_blank" rel="noreferrer"
                                className="w-full bg-rojo text-white text-xs font-bold py-2 rounded-lg hover:bg-rojo-dark transition-colors flex items-center justify-center">
                                {esPdf(d.tipo) ? '📥 Descargar PDF' : '▶️ Ver archivo'}
                              </a>
                            )
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-16 bg-white rounded-2xl border border-gray-100">
                    <div className="text-5xl mb-4">{categoriaActiva.icono}</div>
                    <h3 className="font-condensed text-xl font-black text-azul mb-2">Próximamente</h3>
                    <p className="text-gray-400 text-sm">Estamos preparando el contenido de esta sección.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal imagen grande */}
      {imagenModal && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
          onClick={() => setImagenModal(null)}>
          <div className="relative max-w-4xl w-full">
            <button onClick={() => setImagenModal(null)}
              className="absolute -top-10 right-0 text-white text-2xl hover:text-gray-300">✕</button>
            <img src={imagenModal} alt="Ficha técnica"
              className="w-full h-auto rounded-xl shadow-2xl"
              onClick={e => e.stopPropagation()} />
          </div>
        </div>
      )}
    </main>
  );
}
